export class PdfUtils {

  static openNewTab(pdf) {
    try {
      const blob = pdf.output("blob");
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      setTimeout(() => { try { URL.revokeObjectURL(blobUrl); } catch (_) {} }, 60_000);
    } catch (err) {
      console.error(err);
    }
  }

  static async getBase64ImageFromUrl(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      // Surface the failure but only once per call site — no per-image console spam.
      try { console.error("[PdfUtils] getBase64ImageFromUrl failed:", url, error); } catch (_) {}
      throw error;
    }
  }

}